module.exports = __webpack_public_path__ + "d6feaebac187d9fad0bdaca2b41e3817.pdf";